import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { defaulStateTable } from "@constants/defaultStates"
import { checkParams, getColumnsFilter } from "@thelpers/customTableHelper"
import { useCollectionHistoryServices } from "./useCollectionHistoryServices"
import useRedirectTo from "@thooks/useRedirectTo"
import { columnsCollectionHistoryTableFilters, columnsCollectionHistoryTableHelper } from "../helpers/columnsCollectionHistoryTableHelper"
import useCurrentLocation from "@thooks/useCurrentLocation"

export const useCollectionHistoryTable = () => {

    const { handleRedirectTo } = useRedirectTo()
    const { param, location } = useCurrentLocation()
    const {
        getChargeHistoryByChargeService,
        deleteChargeInstanceService
    } = useCollectionHistoryServices()


    const [loadingCollectionHistoryTable, setLoadingCollectionHistoryTable] = useState(false);
    const [collectionHistoryTable, setCollectionHistoryTable] = useState(structuredClone(defaulStateTable))
    const collectionHistoryTableRef = useRef(defaulStateTable)
    const serviceParams = useMemo(() => ({
        previousData: collectionHistoryTable.dataTable,
        actualLimit: collectionHistoryTable.metadata.limit,
        limit: collectionHistoryTable.metadata.limit,
        currentPage: collectionHistoryTable.currentPage,
        skip: 0
    }), [collectionHistoryTable])

    const getInitialData = useCallback(async ({ charge_id }) => {
        setLoadingCollectionHistoryTable(true)
        const { data, metadata } = await getChargeHistoryByChargeService({
            charge_id,
            setLoading: setLoadingCollectionHistoryTable,
            previousData: collectionHistoryTableRef.dataTable,
            currentPage: collectionHistoryTableRef.currentPage,
            limit: 10
        })
        const defaultData = structuredClone(defaulStateTable)
        const newData = {
            ...defaultData,
            dataTable: data.dataSource,
            currentParams: {
                ...defaulStateTable.currentParams,
            },
            metadata,
        }
        collectionHistoryTableRef.current = { ...newData }
        setCollectionHistoryTable(newData)
        setLoadingCollectionHistoryTable(false)
    }, [getChargeHistoryByChargeService])

    const handleChangeTable = useCallback(async ({ pagination, filter, sorter }) => {
        let sort_order
        if (sorter.order === 'descend') sort_order = 'desc'
        if (sorter.order === 'ascend') sort_order = 'asc'

        const sort_by = sorter.column?.key
        const pageValue = pagination.current || collectionHistoryTable.currentPage
        const newSkip = (pageValue * parseFloat(collectionHistoryTable.metadata.limit)) - parseFloat(collectionHistoryTable.metadata.limit)
        const actualParams = { ...collectionHistoryTable.currentParams }
        const newParams = {
            //Se agrega el nuevo parametro de busqueda
            ...actualParams,
            find_by: actualParams.find_by ?? undefined,
            find_value: actualParams.find_value ?? undefined,
            sort_by,
            sort_order,
            skip: 0
        }
        let newPage = 1

        const finalParams = { ...serviceParams, ...newParams }

        if (checkParams({ actualParams, newParams, difKey: 'skip' })) {
            newPage = pageValue
            finalParams.skip = newSkip
        }

        setLoadingCollectionHistoryTable(true)
        const { data, metadata } = await getChargeHistoryByChargeService({ ...finalParams, setLoading: setLoadingCollectionHistoryTable, charge_id: param.templateId })
        setCollectionHistoryTable({
            ...collectionHistoryTable,
            currentPage: newPage,
            dataTable: data.dataSource,
            metadata: metadata,
            currentParams: newParams,

        })
        setLoadingCollectionHistoryTable(false)
    }, [collectionHistoryTable, serviceParams, param.templateId, getChargeHistoryByChargeService])

    const handleDeleteChargeInstance = useCallback(async ({ charge_instance_id }) => {
        //Eliminar la instancia de cobro
        setLoadingCollectionHistoryTable(true)
        await deleteChargeInstanceService({ charge_instance_id, setLoading: setLoadingCollectionHistoryTable })
        await getInitialData({ charge_id: param.templateId })
    }, [deleteChargeInstanceService, getInitialData, param.templateId])

    const columns = useMemo(() => columnsCollectionHistoryTableHelper({
        columns: collectionHistoryTable.columns,
        handleRedirectTo,
        onDelete: handleDeleteChargeInstance,
        location,
        isDelete: collectionHistoryTable.currentParams?.status === 'deleted'
    }).map((column) => ({
        ...column,
        ...getColumnsFilter(column.dataIndex, columnsCollectionHistoryTableFilters({ currentParams: collectionHistoryTable.currentParams }))
    })), [collectionHistoryTable, location, handleDeleteChargeInstance, handleRedirectTo])

    useEffect(() => {
        getInitialData({ charge_id: param.templateId })
    }, [param.templateId, getInitialData])

    return {
        loadingCollectionHistoryTable,
        collectionHistoryTable,
        handleChangeTable,
        columns
    }
}